<template>
  <div class="issue-severity-chip">
    <div class="severity" :style="style">
      {{ issue.severity }}
    </div>
  </div>
</template>

<script>
import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'IssueSeverityChip',
  props: {
    issue: {
      required: true,
    },
  },
  computed: {
    colorsForLevels() {
      if (this.issue.severity.toLowerCase() === 'informative') {
        return { color: '#4D9FEB' };
      }
      if (this.issue.severity.toLowerCase() === 'critical') {
        return { color: '#DF399F' };
      }
      if (this.issue.severity.toLowerCase() === 'high') {
        return { color: '#FF7F00' };
      }
      if (this.issue.severity.toLowerCase() === 'medium') {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    isScoreCell() {
      return false;
    },
    value() {
      return this.issue?.severity;
    },
    color() {
      if (this.issue.estimatedFixCost === 'Covered by Cynergy') {
        return { color: '#4D9FEB' };
      }
      if (this.issue.impactScore >= 7) {
        return { color: '#DF399F' };
      }
      if (this.issue.impactScore >= 4) {
        return { color: '#FFA600' };
      }
      return { color: '#00D0C4' };
    },
    style() {
      return this.isScoreCell
        ? {
          ...this.color,
          backgroundColor: hexToRgba(this.color.color, 0.1),
          fontSize: '14px',
          minWidth: '37px',
          minHeight: '25px',
          borderRadius: '3px',
        } : {
          backgroundColor: hexToRgba(this.colorsForLevels.color, 0.1),
          ...this.colorsForLevels,
        };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-severity-chip {
  align-items: center;
  display: flex;
  .severity {
    width: rem(90);
    text-transform: capitalize;
    align-items: center;
    display: flex;
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    font-weight: bold;
    letter-spacing: 0;
    line-height: rem(17);
    justify-content: center;
    padding: $space-0-5 $space-1;
    border-radius: $radius-md;
  }
}

</style>
